import CashProcessingBatchSearchResponseBase from './base/CashProcessingBatchSearchResponseBase';

/**
 * @class CashProcessingBatchSearchResponse
 * @extends CashProcessingBatchSearchResponseBase
 */
class CashProcessingBatchSearchResponse extends CashProcessingBatchSearchResponseBase {

}

export default CashProcessingBatchSearchResponse;
